(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('agreementPsychotherapySessionsComponent', agreementPsychotherapySessionsComponent);

    agreementPsychotherapySessionsComponent.$inject = [];

    function agreementPsychotherapySessionsComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectiveAgreementPsychotherapySessionsController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/agreement-psychotherapy-sessions.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveAgreementPsychotherapySessionsController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectiveAgreementPsychotherapySessionsController($scope, $stateParams, $element) {
        var vm = this;

        function init() {
            if (vm.workflow.answer.agreement) {
                if (vm.workflow.answer.agreement.dateSigned === null || vm.workflow.answer.agreement.dateSigned === undefined) {
                    vm.workflow.answer.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        init();
    }
})();
